import React from "react";
import { Box, Typography, Switch } from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";

type SwitchSettingWithDescriptionProps = {
  control: UseFormReturn["control"];
  title: string;
  description: string;
  name: string;
};

export const SwitchSettingWithDescription: React.FC<
  SwitchSettingWithDescriptionProps
> = ({ control, title, description, name }) => {
  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", sm: "row" }}
      alignItems="center"
      mb={2}
      gap={2}
    >
      <Typography
        variant="body2"
        fontWeight="bold"
        sx={{ width: { xs: "100%", sm: "20%" }, mb: { xs: 1, sm: 0 } }}
      >
        {title}
      </Typography>
      <Box
        display="flex"
        alignItems="center"
        sx={{ width: { xs: "100%", sm: "80%" } }}
      >
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Switch {...field} checked={field.value ?? false} />
          )}
        />
        <Typography variant="body2">{description}</Typography>
      </Box>
    </Box>
  );
};
